<template>
	<div class="adv_page">
		<div class="pc_box" v-if="!isPhone">
			<div class="ys_item" :id="item.id" v-for="(item,index) in hxarr" :key="item.id">
				<img class="zt_img" :src="staticImg+item.image">
				<div class="con_wrap" v-if="index==0">
					<div class="zt_con">
						<div class="zt_con_p1">{{ item.title }}</div>
						<div class="zt_con_p2 mt_20" style="color: #333;">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap tran5" v-if="index==1">
					<div class="zt_con" data-aos="fade-left">
						<div class="zt_con_p1">{{ item.title }}</div>
						<br>
						<div class="zt_con_p2">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap tran5" v-if="index==2">
					<div class="zt_con" data-aos="fade-right">
						<div class="zt_con_p1">{{ item.title }}</div>
						<br>
						<div class="zt_con_p2">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap" v-if="index==3">
					<div class="zt_con" data-aos="fade-left">
						<div class="zt_con_p1">{{ item.title }}</div>
						<br>
						<div class="zt_con_p2 mt_20">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap" v-if="index==4">
					<div class="zt_con" data-aos="fade-right">
						<div class="zt_con_p1">{{ item.title }}</div>
						<br>
						<div class="zt_con_p2">{{ item.jieshao }}</div>
					</div>
				</div>
			</div>
			<div class="qh_btn">
				<img @click="qieHuan(1)" src="@/images/hxys/xs.png">
				<img @click="qieHuan(2)" src="@/images/hxys/xx.png">
			</div>
		</div>
		<div class="ph_box" v-if="isPhone">
			<enHeader2 :searchShow="true" pageTitle="Core advantages"></enHeader2>
			<div class="ys_item" :id="item.id" v-for="(item,index) in hxarr" :key="item.id">
				<img class="zt_img" :src="staticImg+item.images">
				<div class="con_wrap" v-if="index==0">
					<div class="zt_con" data-aos="fade-up">
						<div class="zt_con_p1">{{ item.title }}</div>
						<div class="zt_con_p2" style="color: #333;">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap" v-if="index==1" style="left: 0;">
					<div class="zt_con" data-aos="fade-up">
						<div class="zt_con_p1">{{ item.title }}</div>
						<div class="zt_con_p2">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap tran5" v-if="index==2">
					<div class="zt_con" data-aos="fade-up">
						<div class="zt_con_p1">{{ item.title }}</div>
						<div class="zt_con_p2 mt_20">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap tran5" v-if="index==3" style="left: 0;">
					<div class="zt_con" data-aos="fade-up">
						<div class="zt_con_p1">{{ item.title }}</div>
						<div class="zt_con_p2">{{ item.jieshao }}</div>
					</div>
				</div>
				<div class="con_wrap" v-if="index==4">
					<div class="zt_con" data-aos="fade-up">
						<div class="zt_con_p1">{{ item.title }}</div>
						<div class="zt_con_p2 mt_20">{{ item.jieshao }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			hxarr: [],
			isPhone: this.$isMobile,
			staticImg: this.$staticImg,
		}
	},
	mounted() {
		// 监听滚动事件
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		// 移除滚动事件监听
		window.removeEventListener('scroll', this.handleScroll);
	},
	created() {
		this.eadvys();
	},
	methods: {
		// 首页名酒
		async eadvys() {
			const res = await this.$api.eadvys();
			if (res.code == 1) {
				this.hxarr = res.data;
			}
		},
		handleScroll() { },
		qieHuan(a) {
			if (a == 1) {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}
			if (a == 2) {
				const documentHeight = Math.max(
					document.body.scrollHeight,
					document.documentElement.scrollHeight,
					document.body.offsetHeight,
					document.documentElement.offsetHeight,
					document.body.clientHeight,
					document.documentElement.clientHeight
				);
				// 滚动到页面底部
				window.scrollTo({
					top: documentHeight,
					behavior: 'smooth'
				});
			}
		},
	}
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.adv_page {
	@font-face {
		font-family: "SourceHanSerif";
		src: url("../../font/SourceHanSerifCN-Regular.otf");
	}
	font-family: "SourceHanSerif";
	.pc_box {
		padding-top: 60px;
		min-width: 1050px;
		.tran5 {
			background-color: rgba(0, 0, 0, 0.5);
		}
		.zt_con {
			width: vw(750);
			background-image: url("../../images/hxys/yun.png");
			background-repeat: no-repeat;
			background-position: top left;
			.zt_con_p1 {
				font-size: vw(50);
				line-height: 1.8;
				font-weight: bold;
				color: #c4a156;
				text-align: left;
				padding-left: vw(36);
				padding-top: vw(5);
			}
			.zt_con_p2 {
				width: vw(580);
				text-align: left;
				color: #fff;
				line-height: 2.1;
				font-size: 16px;
				padding-left: vw(36);
			}
		}
		.qh_btn {
			position: fixed;
			right: 30px;
			bottom: vw(175);
			z-index: 9;
			width: vw(68);
			img {
				width: vw(68);
				margin-bottom: 20px;
				cursor: pointer;
			}
		}
		.ys_item {
			width: 100%;
            min-height: 300px;
			position: relative;
			.zt_img {
				width: 100%;
				display: block;
				margin-top: 16px;
			}
			.con_wrap {
				position: absolute;
				top: 0;
				bottom: 0;
				width: 50%;
				z-index: 8;
				box-sizing: border-box;
				padding-top: vw(123);
				padding-left: vw(80);
				right: 0;
			}
			&:nth-child(1) {
				.con_wrap {
					left: 0;
				}
			}
			&:nth-child(3) {
				.con_wrap {
					left: 0;
				}
			}
            &:nth-child(5) {
				.con_wrap {
					left: 0;
				}
			}
		}
	}
	@media screen and (max-width: 1700px) {
		.pc_box {
			.zt_con {
				width: vw(800);
				.zt_con_p1 {
					padding-top: vw(15);
					padding-left: vw(50);
				}
				.zt_con_p2 {
					width: vw(650);
					padding-left: vw(50);
				}
			}
			.ys_item {
				.con_wrap {
					padding-top: vw(123);
					padding-left: vw(80);
					right: 0;
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.pc_box {
			.zt_con {
				width: vw(800);
				background-image: url("../../images/hxys/yun.png");
				.zt_con_p1 {
					padding-top: vw(20);
					padding-left: vw(50);
				}
				.zt_con_p2 {
					width: vw(700);
					padding-left: vw(50);
				}
			}
			.ys_item {
				.con_wrap {
					padding-top: vw(123);
					padding-left: vw(80);
					right: 0;
				}
			}
		}
	}
	@media screen and (max-width: 1500px) {
		.pc_box {
			.zt_con {
				width: vw(850);
				background-image: url("../../images/hxys/yun.png");
				.zt_con_p1 {
					padding-top: vw(30);
					padding-left: vw(50);
				}
				.zt_con_p2 {
					width: vw(800);
					padding-left: vw(50);
					font-size: 15px;
				}
			}
			.ys_item {
				.con_wrap {
					padding-top: vw(80);
					padding-left: vw(60);
				}
			}
		}
	}
	@media screen and (max-width: 1300px) {
		.pc_box {
			padding-top: 50px;
			.zt_con {
				width: calc(100vw - 200px);
				.zt_con_p1 {
					font-size: 30px;
					line-height: 1.8;
					padding-left: 30px;
					padding-top: 20px;
				}
				.zt_con_p2 {
					width: calc(100vw - 200px);
					line-height: 1.8;
					font-size: 16px;
					padding-left: 0;
					margin-top: 30px;
				}
			}
			.ys_item {
				.con_wrap {
					right: 100px;
					left: 100px;
					width: calc(100vw - 200px);
					padding-top: 60px;
					padding-left: 0;
					background-color: transparent;
				}
				&:nth-child(1) {
					.con_wrap {
						left: 100px;
					}
				}
				&:nth-child(2) {
					.con_wrap {
						left: 100px;
					}
				}
				&:nth-child(3) {
					.con_wrap {
						left: 100px;
					}
				}
				&:nth-child(4) {
					.con_wrap {
						left: 100px;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1000px) {
		.pc_box {
			padding-top: 50px;
			.zt_con {
				width: 800px;
				.zt_con_p1 {
					font-size: 30px;
				}
				.zt_con_p2 {
					width: 800px;
				}
			}
			.ys_item {
				.con_wrap {
					width: 800px;
				}
			}
		}
	}
	.ph_box {
		padding-top: 1.23rem;
		.ys_item {
			width: 100%;
			position: relative;
			.zt_img {
				width: 100%;
				display: block;
			}
			.con_wrap {
				position: absolute;
				top: 0;
				bottom: 0;
				width: 100%;
				z-index: 8;
				box-sizing: border-box;
				padding: 1rem 0.8rem;
				.zt_con {
					background-image: url("../../images/hxys/yun.png");
					background-repeat: no-repeat;
					background-position: top left;
					background-size: 1.3rem;
					.zt_con_p1 {
						font-size: 0.58rem;
						line-height: 1.9;
						font-weight: bold;
						color: #c4a156;
						text-align: left;
						padding-left: 0.6rem;
						padding-top: 0.1rem;
					}
					.zt_con_p2 {
						text-align: left;
						color: #fff;
						line-height: 2;
						font-size: 0.317rem;
						padding-left: 0.5rem;
						margin-top: 0.4rem;
					}
				}
			}
		}
	}
}
</style>